export default "__VITE_ASSET__9079e361__"